import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	remainingOptions: {
		id: 'portfolio-3-portfolio.app-export-view.main.view-information.filter.custom-fields.remaining-options',
		defaultMessage: '+{count} {count, plural, one {more option} other {more options}}',
		description:
			'The label to show the number of custom fields truncated within the export view filter information',
	},
});
